/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";

function KeyInCashGrid({ data }) {
  const sortedData =
    data?.sort(
      (a, b) => b.denomination?.split(" ")[1] - a.denomination?.split(" ")[1]
    ) || [];
  return (
    <Grid data={sortedData}>
      <GridColumn field="denomination" title="Denomination" />
      <GridColumn field="shape" title="Shape" className="text-center" />
      <GridColumn
        field="count"
        title="Count"
        format="{0:N0}"
        className="text-center"
      />
      <GridColumn
        field="amount"
        title="Amount"
        format="{0:N2}"
        className="text-center"
      />
    </Grid>
  );
}

export default React.memo(KeyInCashGrid);
